import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { ImageList } from 'src/components/shared/templates/footer/AllBrands/ImageList';
import { type Props } from 'src/components/shared/templates/footer/OriginalFooter';
import { KaimonoWebRoutes } from 'src/config/routes';
import { I18nContext } from 'src/stores/I18n';
import type { LOCALE_TYPE } from 'src/types/locale';
import { convertLocaleForZendesk } from 'src/utils/convertLocaleForZendesk';

export const Guide: React.FC<Props> = ({ headingLevel }) => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);
  const Heading = headingLevel === 'h2' ? 'h2' : 'h3';
  const serviceGuideList = [
    {
      link: KaimonoWebRoutes.customerSupport,
      title: localeResources.customerSupport.title
    },
    {
      link: KaimonoWebRoutes.guide,
      title: localeResources.guide.title
    },
    {
      link: KaimonoWebRoutes.walkthrough,
      title: localeResources.staticWalkthrough.title
    },
    {
      link: KaimonoWebRoutes.taxfreeGuide,
      title: localeResources.taxFreeGuide.title
    },
    {
      link: `https://wamazing.zendesk.com/hc/${convertLocaleForZendesk(locale as LOCALE_TYPE)}/categories/360003010811`,
      title: localeResources.products.medicine.Information.title
    }
  ];

  const footerImageList = [
    { path: '/common/footer/japan-tax-free.webp', width: 120, height: 54 },
    { path: '/common/footer/privacy-security.webp', width: 162, height: 62 },
    { path: '/common/footer/product-authentication.webp', width: 148, height: 62 }
  ];

  return (
    <div className="w-full semiLg:max-w-[456px] flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <Heading className="border-b border-black border-solid px-5 py-2">
          {localeResources.footer.serviceGuide}
        </Heading>
        <ul className="grid grid-cols-2 gap-2">
          {serviceGuideList.map((list) => (
            <li className="text-sm py-2 px-5" key={list.link}>
              {list.link.startsWith('https') ? (
                <a
                  href={list.link}
                  className="hover:text-gray700 hover:opacity-70 hover:border-b hover:border-b-black hover:border-solid transition-opacity duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {list.title}
                </a>
              ) : (
                <Link href={list.link}>
                  <a className="hover:text-gray700 hover:opacity-70 hover:border-b hover:border-b-black hover:border-solid transition-opacity duration-200">
                    {list.title}
                  </a>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="hidden semiLg:flex justify-center">
        <ImageList footerImageList={footerImageList} />
      </div>
    </div>
  );
};
